import {acCategoryTypes} from "./type";
import {BaseAction} from "../../actions/base";

const types = acCategoryTypes;

const path = `iot/ac-category`;

const base = new BaseAction(types);

export const getAcCategoryDatas = () => (dispatch) => {
    return base.getDatas(path, dispatch);
};

export const getDeletedAcCategoryDatas = () => (dispatch) => {
    return base.getDatas(`${path}/deleted`, dispatch);
};

export const getAcCategoryData = (id) => (dispatch) => {
    return base.getData(`${path}/${id}`, dispatch);
};

export const getDeletedAcCategoryData = (id) => (dispatch) => {
    return base.getData(`${path}/${id}/deleted`, dispatch);
};

export const addAcCategoryData = (newData) => (dispatch) => {
    return base.addData(path, dispatch, newData);
};

export const editAcCategoryData = (id, newData) => (dispatch) => {
    return base.editData(`${path}/${id}`, dispatch, newData);
};

export const deleteAcCategoryData = (id) => (dispatch) => {
    return base.deleteData(`${path}/${id}`, dispatch, id);
};

export const restoreAcCategoryData = (id) => (dispatch) => {
    return base.restoreData(`${path}/${id}/restore`, dispatch, id);
};

export const hardDeleteAcCategoryData = (id) => (dispatch) => {
    return base.hardDeleteData(`${path}/${id}/confirmdelete`, dispatch, id);
};
